import React, {Component} from 'react';
import {Card, CardBody, CardImage, CardTitle, CardText, Container, Col, Row, Fa} from "mdbreact";
import {Link} from "react-router-dom";
import "./../../assets/images/help/hub_bigHeader.png";

import { Player } from 'video-react';

import "./../../../node_modules/video-react/dist/video-react.css";



export default class HelpItem extends Component {
    render() {
        return (
            <div >
                <div className="jumbotron text-center rtl" style={{background:"#000 url(./../../assets/images/help/hub_bigHeader.png) no-repeat center bottom"}}>

                    <div className="container d-flex justify-content-start align-self-stretch  mt-5">
                        <div className="p-2 text-right rtl">
                            <h1 className="pag-title text-white">مرکز آموزش</h1>
                        </div>
                        <div className="ml-auto p-2">

                        </div>
                    </div>
                </div>
                <Container className="mt-5 mb-5 rtl">
                    <Row>
                            <h1 className="blue-grey-text mt-3 mb-4">عنوان آموزش</h1>
                    </Row>
                    <Row>
                            <div className="w-100 border border-info">
                                <Player
                                    playsInline
                                    poster="./../../assets/media/intro.jpg"
                                    src="./../../assets/media/1.mp4"
                                />
                            </div>
                    </Row>
                    <Row className="mt-4 mb-5">
                        <h3>پاراگراف اول</h3>
                        <p className="text-justify rtl">
                            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.
                        </p>
                        <h3>پاراگراف دوم</h3>
                        <p className="text-justify rtl">
                            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.
                        </p>
                    </Row>

                </Container>
                <Container className="rtl" >
                    <Row className="">
                        <h4>موارد مشابه</h4>
                    </Row>
                    <hr/>
                    <Row className="mt-5 mb-5">
                        <Col md="4" sm="2" className="mb-5">
                            <Card>
                                <CardImage className="img-fluid" src="./../../assets/images/help/default_img.jpg" />
                                <CardBody>
                                    <CardTitle>
                                        <Link to='/faq/1'>عنوان آموزش</Link>
                                    </CardTitle>
                                    <CardText className="text-justify">
                                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.
                                    </CardText>
                                    <hr/>
                                    <div className="d-flex justify-content-between">

                                        <div className="grey-text p-2">
                                            <Fa icon="calendar"/>
                                            <span>22 May, 2016</span>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="film" className="amber-text"/>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="thumbs-o-up "  className="blue-text"/>
                                            <span>239</span>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="eye" className="blue-text"/>
                                            <span>11792</span>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md="4" sm="2" className="mb-5">
                            <Card>
                                <CardImage className="img-fluid" src="./../../assets/images/help/Ping_Offers.jpg" />
                                <CardBody>
                                    <CardTitle>
                                        <Link to='/faq/2'>عنوان آموزش</Link>
                                    </CardTitle>
                                    <CardText className="text-justify">
                                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.
                                    </CardText>
                                    <hr/>
                                    <div className="d-flex justify-content-between">

                                        <div className="grey-text p-2">
                                            <Fa icon="calendar"/>
                                            <span>22 May, 2016</span>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="film" className="amber-text"/>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="thumbs-o-up "  className="blue-text"/>
                                            <span>239</span>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="eye" className="blue-text"/>
                                            <span>11792</span>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md="4" sm="2" className="mb-5">
                            <Card>
                                <CardImage className="img-fluid" src="./../../assets/images/help/Hotels_Worldwide.jpg" />
                                <CardBody>
                                    <CardTitle>
                                        <Link to='/faq/3'>عنوان آموزش</Link>
                                    </CardTitle>
                                    <CardText className="text-justify">
                                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.
                                    </CardText>
                                    <hr/>
                                    <div className="d-flex justify-content-between">

                                        <div className="grey-text p-2">
                                            <Fa icon="calendar"/>
                                            <span>22 May, 2016</span>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="film" className="amber-text"/>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="thumbs-o-up "  className="blue-text"/>
                                            <span>239</span>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="eye" className="blue-text"/>
                                            <span>11792</span>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>


                    </Row>
                </Container>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/containers/faq/HelpItem.js